import {
  EntitiesDomainFieldIdType,
  EntitiesDomainFieldLabelType,
  EntitiesIpAddressesFieldIdType,
  EntitiesIpAddressesFieldLabelType,
  EntitiesOpenPortsFieldIdType,
  EntitiesOpenPortsFieldLabelType,
  EntitiesSubdomainFieldIdType,
  EntitiesSubdomainFieldLabelType,
  EntitiesVulnerabilitiesCVEFieldIdType,
  EntitiesVulnerabilitiesCVEFieldLabelType,
  EntitiesVulnerabilitiesFieldIdType,
  EntitiesVulnerabilitiesFieldLabelType,
} from '@converge/data';
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  EntitiesDomainsData,
  EntitiesDomainsSubdomainData,
  EntitiesIPAddressAttackSurfaceData,
} from '@converge/graphql';

import { Chip } from '@mui/material';
import { ITableColumn } from '../../../presentation/components';
import { bitToYesNo } from '@converge/utils';

export interface IEntitiesOpenPortsUIData {
  ip?: string | null;
  protocol?: string;
  port?: number;
  isFirstRecord: boolean;
  totalRecords: number;
}

export enum Risk {
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
}

// const RiskIcon = ({ risk }: { risk: Risk }) => {
//   return (
//     <ConvergeTooltip title={`${risk} risk`}>
//       <Circle
//         color={
//           risk === Risk.High
//             ? 'error'
//             : risk === Risk.Medium
//             ? 'warning'
//             : 'success'
//         }
//       />
//     </ConvergeTooltip>
//   );
// };

export const domainColumns: ITableColumn<EntitiesDomainsData, void>[] = [
  {
    id: EntitiesDomainFieldIdType.Domain,
    label: EntitiesDomainFieldLabelType.Domain,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row?.domain ?? '',
  },
  {
    id: EntitiesDomainFieldIdType.DKIM,
    label: EntitiesDomainFieldLabelType.DKIM,
    render: (row) => bitToYesNo(row?.dkim),
  },
  {
    id: EntitiesDomainFieldIdType.SPF,
    label: EntitiesDomainFieldLabelType.SPF,
    render: (row) => bitToYesNo(row?.spf),
  },
  {
    id: EntitiesDomainFieldIdType.Subdomains,
    label: EntitiesDomainFieldLabelType.Subdomains,
    render: (row) => row?.subDomains.pageInfo.totalResults,
  },
  // {
  //   id: EntitiesDomainFieldIdType.Risk,
  //   label: EntitiesDomainFieldLabelType.Risk,
  //   visible: true,
  //   render: (row) => {
  //     const randomNumber = Math.random();

  //     const riskLevel =
  //       DOMAIN_RISK_LEVELS[row.uuid] ??
  //       (randomNumber > 2 / 3
  //         ? Risk.High
  //         : randomNumber > 1 / 3
  //         ? Risk.Medium
  //         : Risk.Low);

  //     if (!DOMAIN_RISK_LEVELS[row.uuid]) {
  //       DOMAIN_RISK_LEVELS[row.uuid] = riskLevel;
  //     }

  //     return <RiskIcon risk={riskLevel} />;
  //   },
  // },
];

export const domainChildColumns: ITableColumn<
  EntitiesDomainsSubdomainData,
  EntitiesDomainsData
>[] = [
  {
    id: EntitiesSubdomainFieldIdType.Subdomain,
    label: EntitiesSubdomainFieldLabelType.Subdomain,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row?.name ?? '',
  },
  {
    id: EntitiesSubdomainFieldIdType.DMARC,
    label: EntitiesSubdomainFieldLabelType.DMARC,
    render: (row) => bitToYesNo(row?.dmarc),
  },
];

export const ipColumns: ITableColumn<
  EntitiesIPAddressAttackSurfaceData,
  void
>[] = [
  {
    id: EntitiesIpAddressesFieldIdType.IPAddress,
    label: EntitiesIpAddressesFieldLabelType.IPAddress,
    render: (row) => {
      return <Chip label={row.ipv4Address || 'N/A'}></Chip>;
    },
  },
  {
    id: EntitiesIpAddressesFieldIdType.Version,
    label: EntitiesIpAddressesFieldLabelType.Version,
    render: (row) => (row.ipv4Address ? 'IPv4' : 'N/A'),
  },
  {
    id: EntitiesIpAddressesFieldIdType.OpenPorts,
    label: EntitiesIpAddressesFieldLabelType.OpenPorts,
    render: (row) => row.portCount || 0,
  },
  {
    id: EntitiesIpAddressesFieldIdType.Vulnerabilities,
    label: EntitiesIpAddressesFieldLabelType.Vulnerabilities,
    render: (row) => row.vulnerabilityCount || 0,
  },
  // {
  //   id: EntitiesIpAddressesFieldIdType.Risk,
  //   label: EntitiesIpAddressesFieldLabelType.Risk,
  //   visible: true,
  //   render: (row) => {
  //     const randomNumber = Math.random();

  //     const riskLevel =
  //       IP_RISK_LEVELS[row.uuid ?? ''] ??
  //       (randomNumber > 2 / 3
  //         ? Risk.High
  //         : randomNumber > 1 / 3
  //         ? Risk.Medium
  //         : Risk.Low);

  //     if (!IP_RISK_LEVELS[row.uuid ?? '']) {
  //       IP_RISK_LEVELS[row.uuid ?? ''] = riskLevel;
  //     }

  //     return <RiskIcon risk={riskLevel} />;
  //   },
  // },
];

export const openPortsColumns: ITableColumn<any, void>[] = [
  {
    id: EntitiesOpenPortsFieldIdType.Port,
    label: EntitiesOpenPortsFieldLabelType.Port,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row.node.port ?? 'N/A',
  },
  {
    id: EntitiesOpenPortsFieldIdType.Protocol,
    label: EntitiesOpenPortsFieldLabelType.Protocol,
    render: (row) => row.node.protocol,
  },
  {
    id: EntitiesOpenPortsFieldIdType.IPAddresses,
    label: EntitiesOpenPortsFieldLabelType.IPAddresses,
    render: (row) => {
      return row.node.ipAddresses.length;
    },

    // (row) => {
    //   return row.node.ipAddresses ?
    //     <>
    //     {row.node.ipAddresses.map((ipAddresse: string) => <div> {ipAddresse}</div>)}
    //     </>
    //     :
    //     'No IP addresses'

    // }
  },
];

export const vulnerabilitiesColumns: ITableColumn<any, void>[] = [
  {
    id: EntitiesVulnerabilitiesFieldIdType.CVE,
    label: EntitiesVulnerabilitiesFieldLabelType.CVE,
    render: (row) => (
      <a
        href={`https://nvd.nist.gov/vuln/detail/${row.node.cve}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {row.node.cve || ''}
      </a>
    ),
  },
  {
    id: EntitiesVulnerabilitiesFieldIdType.Cvss,
    label: EntitiesVulnerabilitiesFieldLabelType.Cvss,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => row.node.cvss ?? 'N/A',
  },
  // {
  //   id: EntitiesVulnerabilitiesFieldIdType.MoreInfo,
  //   label: EntitiesVulnerabilitiesFieldLabelType.MoreInfo,
  //   // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
  //   render: (row) => (
  //     <a
  //       href={`https://nvd.nist.gov/vuln/detail/${row.node.cve}`}
  //       target="_blank"
  //       rel="noopener noreferrer"
  //     >
  //       more info
  //     </a>
  //   ),
  // },
  {
    id: EntitiesVulnerabilitiesFieldIdType.IpAddresses,
    label: EntitiesVulnerabilitiesFieldLabelType.IpAddresses,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => {
      return row?.node?.ipAddresses?.edges
        ?.slice(0, 5)
        .map((ipAddress: any) =>
          ipAddress?.node?.ipv4Address ? (
            <Chip sx={{ margin: '4px' }} label={ipAddress?.node?.ipv4Address} />
          ) : (
            'N/A'
          )
        );
    },
  },
  // {
  //   id: EntitiesVulnerabilitiesFieldIdType.Update,
  //   label: EntitiesVulnerabilitiesFieldLabelType.Update,
  //   // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
  //   render: (row) => row.update ?? 'N/A',
  // },
  // {
  //   id: EntitiesVulnerabilitiesFieldIdType.Edition,
  //   label: EntitiesVulnerabilitiesFieldLabelType.Edition,
  //   // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
  //   render: (row) => row.edition ?? 'N/A',
  // },
  // {
  //   id: EntitiesVulnerabilitiesFieldIdType.Language,
  //   label: EntitiesVulnerabilitiesFieldLabelType.Language,
  //   // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
  //   render: (row) => row.language ?? 'N/A',
  // },
  // {
  //   id: EntitiesVulnerabilitiesFieldIdType.Type,
  //   label: EntitiesVulnerabilitiesFieldLabelType.Type,
  //   // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
  //   render: (row) => row.type ?? 'N/A',
  // }
];

export const vulnerabilitiesChildColumns: ITableColumn<any, any>[] = [
  {
    id: EntitiesVulnerabilitiesCVEFieldIdType.Product,
    label: EntitiesVulnerabilitiesCVEFieldLabelType.Product,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => {
      return row.product ?? 'N/A';
    },
  },
  {
    id: EntitiesVulnerabilitiesCVEFieldIdType.Part,
    label: EntitiesVulnerabilitiesCVEFieldLabelType.Part,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => {
      return row.part ?? 'N/A';
    },
  },
  {
    id: EntitiesVulnerabilitiesCVEFieldIdType.Version,
    label: EntitiesVulnerabilitiesCVEFieldLabelType.Version,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => {
      return row.version ?? 'N/A';
    },
  },
  {
    id: EntitiesVulnerabilitiesCVEFieldIdType.Update,
    label: EntitiesVulnerabilitiesCVEFieldLabelType.Update,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => {
      return row.update ?? 'N/A';
    },
  },
  {
    id: EntitiesVulnerabilitiesCVEFieldIdType.Edition,
    label: EntitiesVulnerabilitiesCVEFieldLabelType.Edition,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => {
      return row.edition ?? 'N/A';
    },
  },
  {
    id: EntitiesVulnerabilitiesCVEFieldIdType.Language,
    label: EntitiesVulnerabilitiesCVEFieldLabelType.Language,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => {
      return row.language ?? 'N/A';
    },
  },
];

export const openPortChildColumns: ITableColumn<any, any>[] = [
  {
    id: EntitiesIpAddressesFieldIdType.IPAddress,
    label: EntitiesIpAddressesFieldLabelType.IPAddress,
    // TODO: Remove the fallback after API ticket CON-1589 is done (https://convergeins.atlassian.net/browse/CON-1589)
    render: (row) => {
      return <Chip sx={{ margin: '4px' }} label={row?.ipv4Address} />;
    },
  },
];
